import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const CookiesPopup = () => {
    const { t } = useTranslation('cookies'); // Usando o namespace 'whatsapp'
   const [hasAccepted, setHasAccepted] = useState(null);

   useEffect(() => {
    const accepted = localStorage.getItem('cookies-accepted') === 'true';
    setHasAccepted(accepted);
  }, [hasAccepted]);

  function onClickButton() {
    localStorage.setItem('cookies-accepted', true);
    setHasAccepted(true);
  }

    return (
        <div className={hasAccepted ? "cookies-popup accepted" : "cookies-popup"}>
            <p>{t('text')}</p>
            <button onClick={onClickButton}>{t('button')}</button>
        </div>
    );
};

export default CookiesPopup;
